<template>
  <a-layout class="transaction-form">
    <TitleBreadcrumb />
    <a-spin :spinning="submitting" :tip="labels.submittingText">
      <div class="content-base container">
        <a-alert
          v-if="promotionAvailable"
          :style="{ marginBottom: '15px', marginTop: '15px' }"
          message="Promoción disponible!"
          type="success"
          closable
          show-icon
        >
          <template #icon>
            <font-awesome-icon
              :icon="['fas', 'gift']"
              class="anticon"
              style="color: var(--success)"
            />
          </template>
          <template #description>
            <span
              class="notification"
              v-html="
                labels.promotionAvailableLabel.replace(
                  '{{value}}',
                  promotionAvailable.percentage
                )
              "
            />
          </template>
        </a-alert>
        <!-- NOTIFICATION -->
        <a-alert
          v-if="isWithdraw"
          :style="{ marginBottom: '15px', marginTop: '15px' }"
          message="Horarios de retiros:"
          type="warning"
          closable
          show-icon
        >
          <template #description>
            <span
              class="notification"
              v-html="
                labels.infoLabel.replace(
                  '{{more}}',
                  loggedUser && loggedUser.pwo
                    ? '<span>- Solo se permiten retirar el balance de los tickets premiados.</span>'
                    : ''
                )
              "
            />
          </template>
        </a-alert>
        <a-alert
          v-if="isDeposit"
          :style="{ marginBottom: '15px', marginTop: '15px' }"
          message="Horarios de depositos:"
          type="warning"
          closable
          show-icon
        >
          <template #description>
            <span
              class="notification"
              v-html="
                labels.depositInfoLabel.replace(
                  '{{deposit}}',
                  userDepositPercentageCommission
                    ? labels.depositCommissionInfoLabel.replace(
                        '{{variable}}',
                        userDepositPercentageCommission
                      )
                    : ''
                )
              "
            />
          </template>
        </a-alert>
        <a-card class="transaction-form-card" id="transaction-print-area">
          <ValidationObserver ref="observer">
            <a-form
              :label-width="80"
              slot-scope="{ validate }"
              @submit.prevent=""
            >
              <a-row type="flex" :gutter="[8, 8]">
                <a-col :span="24">
                  <a-radio-group
                    v-model="form.type"
                    :size="isTabletDown ? 'small' : 'large'"
                  >
                    <a-radio-button
                      v-if="
                        $route.query.type === TYPE.DEPOSIT || !$route.query.type
                      "
                      :value="TYPE.DEPOSIT"
                      class="custom-radio-button"
                    >
                      {{ labels.type[TYPE.DEPOSIT] }}
                      <font-awesome-icon
                        :icon="[
                          'far',
                          form.type === TYPE.DEPOSIT ? 'circle-dot' : 'circle',
                        ]"
                        class="anticon flex-icon"
                      />
                    </a-radio-button>
                    <a-radio-button
                      v-if="
                        !loggedUser.dww &&
                        ($route.query.type === TYPE.WITHDRAW ||
                          !$route.query.type)
                      "
                      :value="TYPE.WITHDRAW"
                      class="custom-radio-button"
                      >{{ labels.type[TYPE.WITHDRAW] }}
                      <font-awesome-icon
                        :icon="[
                          'far',
                          form.type === TYPE.WITHDRAW ? 'circle-dot' : 'circle',
                        ]"
                        class="anticon flex-icon"
                      />
                    </a-radio-button>
                    <a-radio-button
                      v-if="
                        $route.query.type === TYPE.TRANSFER ||
                        !$route.query.type
                      "
                      :value="TYPE.TRANSFER"
                      class="custom-radio-button"
                      >{{ labels.type[TYPE.TRANSFER] }}
                      <font-awesome-icon
                        :icon="[
                          'far',
                          form.type === TYPE.TRANSFER ? 'circle-dot' : 'circle',
                        ]"
                        class="anticon flex-icon"
                      />
                    </a-radio-button>
                  </a-radio-group>
                </a-col>
              </a-row>

              <!-- TRANSACTION INFO -->
              <a-divider
                orientation="left"
                class="text-white"
                type="horizontal"
              >
                {{
                  isWithdraw || isTransfer
                    ? labels.transactionInfoLabel
                    : labels.paymentMethodInfoLabel
                }}
              </a-divider>

              <!-- DEPOSIT FORM -->
              <template v-if="isDeposit">
                <a-row type="flex" :gutter="[8, 8]">
                  <a-col
                    :xs="24"
                    :sm="24"
                    :md="
                      isCreditCard && (!isCreditCardEnabled || !loggedUser.upc)
                        ? 24
                        : 12
                    "
                  >
                    <a-row type="flex" :gutter="[8, 8]">
                      <a-col :span="24">
                        <a-radio-group
                          :value="form.origin"
                          :size="isTabletDown ? 'small' : 'large'"
                          class="origin-radio-group"
                          @change="handleChangeOrigin"
                        >
                          <a-radio-button
                            :value="TYPE.TRANSFER"
                            class="origin-radio-button"
                          >
                            <font-awesome-icon
                              :icon="['fas', 'building-columns']"
                              class="anticon"
                            />
                            <span>{{ labels.type[TYPE.BANK_TRANSFER] }}</span>
                          </a-radio-button>
                          <a-radio-button
                            v-if="false"
                            :value="ORIGIN.TETHER"
                            class="origin-radio-button"
                          >
                            <img
                              :src="tetherLogo"
                              :alt="labels.type[ORIGIN.TETHER]"
                              class="tether-icon"
                            />
                            <span>{{ labels.type[ORIGIN.TETHER] }}</span>
                          </a-radio-button>
                          <a-radio-button
                            v-if="!isInBlackList"
                            :value="ORIGIN.CREDIT_CARD"
                            class="origin-radio-button"
                          >
                            <font-awesome-icon
                              :icon="['far', 'credit-card']"
                              class="anticon"
                            />
                            <span>{{ labels.type[ORIGIN.CREDIT_CARD] }}</span>
                          </a-radio-button>
                        </a-radio-group>
                      </a-col>
                      <a-col
                        v-if="
                          acceptedPolicies ||
                          [ORIGIN.TETHER, ORIGIN.CREDIT_CARD].includes(
                            form.origin
                          )
                        "
                        :xs="24"
                        :sm="24"
                        :md="
                          (loggedUser.upc && isCreditCardEnabled) ||
                          !isCreditCard
                            ? 24
                            : 24
                        "
                      >
                        <template
                          v-if="
                            (loggedUser.upc && isCreditCardEnabled) ||
                            !isCreditCard
                          "
                        >
                          <Input
                            ref="amountInput"
                            type="number"
                            v-model="form.amount"
                            rules="required"
                            vid="amount"
                            :placeholder="labels.amount.placeholder"
                            size="large"
                            :allowClear="true"
                            :label="labels.amount.label"
                            :step="isCreditCard ? 200 : 100"
                            v-bind="
                              isWithdraw || isTransfer
                                ? { max: userBalance }
                                : {}
                            "
                            :min="
                              isSeller && !isCreditCard
                                ? 2000
                                : isCreditCard
                                ? minCreditCardAmount
                                : 100
                            "
                            @pressEnter.prevent="scrollIntoView($refs.upload)"
                          />
                          <div
                            class="frequent-amounts-container"
                            v-if="
                              [ORIGIN.TETHER, ORIGIN.TRANSFER].includes(
                                form.origin
                              )
                            "
                          >
                            <a-button
                              v-for="(amount, key) in isSeller
                                ? [2000, 3500, 5000, 6500]
                                : labels.btnAmounts"
                              :key="key"
                              class="btn-frequent-amount"
                              @click="setAmount(amount)"
                              >{{ amount }}</a-button
                            >
                          </div>
                          <div
                            class="frequent-amounts-container"
                            v-if="isCreditCard && !isInBlackList"
                          >
                            <a-button
                              v-for="(amount, key) in [2000, 3500, 5000, 6500]"
                              :key="key"
                              class="btn-frequent-amount"
                              @click="setAmount(amount)"
                              >{{ amount }}</a-button
                            >
                          </div>
                        </template>
                        <template
                          v-if="
                            isCreditCard &&
                            (!isCreditCardEnabled || !loggedUser.upc)
                          "
                        >
                          <a-alert
                            style="margin-top: 30px"
                            message="Importante!"
                            type="info"
                            show-icon
                          >
                            <span
                              slot="description"
                              v-html="
                                loadVariable(
                                  labels.isCreditCardEnabledMessage,
                                  {
                                    numero: whatsappLinkMessage(
                                      labels.whatsappMessage2
                                    ),
                                    clickhere: labels.clickhere,
                                  }
                                )
                              "
                            />
                          </a-alert>
                        </template>
                      </a-col>
                      <a-col :span="24">
                        <!-- VOUCHER INFO -->
                        <template v-if="form.origin === ORIGIN.TRANSFER">
                          <a-divider
                            orientation="left"
                            class="text-white"
                            type="horizontal"
                          >
                            {{ labels.vouchersLabel }}
                          </a-divider>
                          <a-row :gutter="[16, 16]" type="flex" justify="start">
                            <a-col :span="24">
                              <a-form-item :style="{ width: '100%' }">
                                <a-upload
                                  ref="upload"
                                  :disabled="submitting"
                                  :multiple="true"
                                  :accept="'image/*'"
                                  :file-list="fileList"
                                  list-type="picture"
                                  :style="{ width: '100%' }"
                                  :beforeUpload="beforeUpload"
                                  :openFileDialogOnClick="true"
                                  :remove="handleRemoveFile"
                                  @preview="handlePreviewFile"
                                  :customRequest="dummyRequest"
                                >
                                  <a-button
                                    size="large"
                                    type="primary"
                                    ghost
                                    class="btn-upload"
                                    :disabled="submitting"
                                    :block="true"
                                    :style="{ width: '100%' }"
                                  >
                                    <a-icon type="upload" />
                                    {{ labels.voucher.label }}
                                  </a-button>
                                </a-upload>
                              </a-form-item>
                            </a-col>
                          </a-row>
                        </template>
                      </a-col>
                    </a-row>
                  </a-col>
                  <a-col :xs="24" :sm="24" :md="12">
                    <div
                      v-if="form.origin === ORIGIN.TRANSFER"
                      class="deposit-tips-container"
                    >
                      <ol class="deposit-tips">
                        <li
                          v-for="(label, key) in labels.depositTips"
                          :key="key"
                          v-html="
                            key === 0
                              ? loadVariable(label, {
                                  link: depositAccountsLink,
                                })
                              : label
                          "
                        />
                      </ol>
                    </div>
                    <div
                      v-else-if="form.origin === ORIGIN.TETHER"
                      class="tether-tips-container"
                    >
                      <p
                        class="tether-tips"
                        v-html="labels.tetherTips.description"
                      />
                      <a-button
                        :disabled="!isTetherValid"
                        class="btn-tether"
                        type="link"
                        :href="tetherLink"
                        block
                        target="_blank"
                        ><span v-html="labels.tetherTips.linkLabel"
                      /></a-button>

                      <a-spin
                        :spinning="loadingQRCode"
                        :tip="labels.loadingQRCode"
                        class="tether-qr-code-container"
                      >
                        <div class="tether-qr-code">
                          <img
                            v-if="
                              !loadingQRCode && paymentBase64 && form.amount
                            "
                            class="tether-qr"
                            :src="paymentBase64"
                            alt="Payment QR Code"
                          />
                          <template
                            v-if="!loadingQRCode && paymentUri && form.amount"
                          >
                            <div class="tether-dir">
                              <h3>{{ labels.tetherDirTitle }}</h3>
                              <span>{{ paymentUri }}</span>
                            </div>
                            <div class="tether-footer">
                              <a-button
                                type="link"
                                @click="copyPaymentUriToClipboard"
                              >
                                <a-icon type="copy" />
                                {{ labels.copyToClipboard }}
                              </a-button>
                            </div>
                          </template>
                        </div>
                      </a-spin>
                    </div>
                    <div
                      v-else-if="form.origin === ORIGIN.CREDIT_CARD"
                      class="credit-card-tips-container"
                    >
                      <a-card
                        size="small"
                        class="card-credit-card-client"
                        :loading="loadingCreditCardClientLinks"
                        v-if="creditCardClient || loadingCreditCardClientLinks"
                        width="100%"
                      >
                        <div class="table-credit-card-client">
                          <div class="table-row-credit-card-client">
                            <span>{{
                              labels.creditCardClientTips.amount
                            }}</span>
                            <span>{{
                              (form?.amount || 0) | formatCurrency
                            }}</span>
                          </div>
                          <div class="table-row-credit-card-client">
                            <span>{{ labels.creditCardClientTips.fee }}</span>
                            <span>{{
                              ((form?.amount || 0) *
                                (creditCardClient?.percentage / 100))
                                | formatCurrency
                            }}</span>
                          </div>
                          <div class="table-row-credit-card-client total">
                            <span>{{ labels.creditCardClientTips.total }}</span>
                            <span>{{
                              ((form?.amount || 0) *
                                (1 + creditCardClient?.percentage / 100))
                                | formatCurrency
                            }}</span>
                          </div>
                        </div>
                      </a-card>
                    </div>
                  </a-col>
                </a-row>
              </template>

              <!-- WITHDRAW FORM -->
              <template v-if="isWithdraw">
                <!-- TRANSACTION INFO -->
                <a-row type="flex" :gutter="[8, 8]">
                  <a-col :xs="24" :sm="24" :md="12">
                    <Input
                      ref="amountInput"
                      type="number"
                      v-model="form.amount"
                      inputmode="numeric"
                      rules="required"
                      vid="amount"
                      :placeholder="labels.amount.placeholder"
                      size="large"
                      :allowClear="true"
                      :label="labels.amount.label"
                      v-bind="(isWithdraw || isTransfer) && { max: balance }"
                      :min="isWithdraw ? 200 : 1"
                    />
                    <div class="frequent-amounts-container">
                      <a-button
                        v-for="(amount, key) in labels.btnAmounts"
                        :key="key"
                        class="btn-frequent-amount"
                        @click="setAmount(amount)"
                        >{{ amount }}</a-button
                      >
                    </div>
                  </a-col>
                  <a-col :xs="24" :sm="24" :md="12">
                    <!-- Balance disponible para retiro -->
                    <a-card
                      type="inner"
                      :style="{ background: 'transparent', height: '100%' }"
                    >
                      <a-statistic
                        class="withdraw-info"
                        prefix="$"
                        :value-style="{ color: 'var(--text-warning)' }"
                        :value="
                          loggedUser && loggedUser.pwo
                            ? userWithdrawBalance
                            : userBalance
                        "
                      >
                        <template #title>
                          {{ labels.withdrawInfoLabel }}
                          <a-tooltip
                            trigger="click"
                            placement="topRight"
                            overlayClassName="custom-tooltip"
                          >
                            <template slot="title">
                              <p>
                                El monto disponible para retiro esta confirmado
                                por los montos ganados en premios y las
                                comisiones por referidos.
                              </p>
                              <p>
                                Como se indica en nuestros
                                <router-link
                                  :to="{ name: 'terms-and-conditions' }"
                                  target="_blank"
                                  >terminos y condiciones</router-link
                                >
                                , no procesamos retiros de:
                              </p>
                              <ul>
                                <li>Depositos</li>
                                <li>Bonos Por Depositos</li>
                              </ul>
                            </template>
                            <a-icon type="info-circle" class="click" />
                          </a-tooltip>
                        </template>
                      </a-statistic>

                      <!-- TRANSFER WITHDRAW BALANCE BUTTON -->
                      <template
                        v-if="
                          loggedUser &&
                          loggedUser.pwo &&
                          loggedUser.atwb &&
                          loggedUser.withdraw_balance >= 1000
                        "
                      >
                        <hr />
                        <div class="withdraw-balance-container">
                          <a-button
                            type="primary"
                            @click="openModalTransferWithdrawBalance"
                            class="btn-withdraw"
                            size="large"
                            ghost
                            block
                          >
                            {{ labels.transferWithdrawBalance.btnTransfer }}
                          </a-button>

                          <a-tooltip
                            @click.prevent
                            trigger="click"
                            placement="topRight"
                            overlayClassName="custom-tooltip"
                          >
                            <template slot="title">
                              <p>
                                {{ labels.transferWithdrawBalance.info }}
                              </p>
                            </template>
                            <a-icon
                              type="info-circle"
                              class="click icon-info"
                            />
                          </a-tooltip>
                        </div>
                      </template>
                    </a-card>
                  </a-col>
                </a-row>

                <!-- BANK ACCOUNT INFO -->
                <a-divider
                  orientation="left"
                  class="text-white"
                  type="horizontal"
                >
                  {{ labels.bankInfoLabel }}
                </a-divider>
                <validation-provider
                  vid="account"
                  name="Cuenta bancaria"
                  rules="required"
                >
                  <user-bank-account-component
                    slot-scope="{ errors }"
                    v-model="bankAccount"
                    :labels="labels"
                    :error="errors[0]"
                  />
                </validation-provider>
              </template>

              <!-- TRANSFER FORM -->
              <template v-if="isTransfer">
                <a-row type="flex" justify="space-between" :gutter="[8, 8]">
                  <a-col :md="8" :sm="24" :xs="24">
                    <Input
                      v-model="form.destination_account_phone"
                      rules="required|phoneNumber"
                      vid="destinationAccountPhone"
                      :placeholder="labels.destinationAccountPhone.placeholder"
                      size="large"
                      :allowClear="true"
                      :label="labels.destinationAccountPhone.label"
                      v-themask="['(###) ###-####']"
                    />
                    <Input
                      ref="amountInput"
                      type="number"
                      v-model="form.amount"
                      rules="required"
                      vid="amount"
                      :placeholder="labels.amount.placeholder"
                      size="large"
                      :allowClear="true"
                      :label="labels.amount.label"
                      v-bind="
                        (isWithdraw || isTransfer) && { max: userBalance }
                      "
                      :min="1"
                    />
                    <div class="frequent-amounts-container">
                      <a-button
                        v-for="(amount, key) in labels.btnAmounts"
                        :key="key"
                        class="btn-frequent-amount"
                        @click="setAmount(amount)"
                        >{{ amount }}</a-button
                      >
                    </div>
                  </a-col>
                  <a-col
                    v-if="form.destination_account_phone && form.amount"
                    :md="8"
                    :sm="24"
                    :xs="24"
                  >
                    <div class="transfer-total">
                      <h4 class="transfer-total-title">
                        {{ labels.transfer.title }}
                      </h4>
                      <div class="transfer-total-details-item">
                        <span class="label">{{ labels.transfer.amount }}</span>
                        <span class="value">{{
                          form.amount | formatNumber
                        }}</span>
                      </div>
                      <div class="transfer-total-details-item">
                        <span class="label"
                          >{{ labels.transfer.charges
                          }}{{ transferFee ? ` (${transferFee}%)` : "" }}</span
                        >
                        <span class="value">{{
                          (form.amount * (transferFee / 100)) | formatNumber
                        }}</span>
                      </div>
                      <div class="transfer-total-details-item bordered">
                        <span class="label">{{ labels.transfer.total }}</span>
                        <span class="value">{{
                          (form.amount + form.amount * (transferFee / 100))
                            | formatNumber
                        }}</span>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </template>

              <a-row
                v-if="![ORIGIN.TETHER].includes(form.origin)"
                type="flex"
                justify="center"
                :style="{ alignItems: 'center' }"
                :gutter="[24, 24]"
              >
                <a-col :span="24">
                  <a-form-item style="text-align: center">
                    <a-button
                      v-if="!isCreditCard"
                      type="primary"
                      :loading="submitting"
                      :disabled="
                        submitting ||
                        (isDeposit &&
                          !acceptedPolicies &&
                          form.origin !== ORIGIN.TRANSFER)
                      "
                      size="large"
                      class="btn-submit"
                      @click="
                        validate().then(
                          isTransfer ? handleConfirmPassword : handleSubmit
                        )
                      "
                      block
                    >
                      <font-awesome-icon
                        v-if="!submitting"
                        :icon="['fas', 'paper-plane']"
                        class="anticon"
                      />
                      {{ labels.submit }}
                    </a-button>
                    <a-button
                      v-if="
                        isCreditCard && isCreditCardEnabled && loggedUser.upc
                      "
                      class="btn-submit"
                      type="default"
                      size="large"
                      @click="handleCreditCardPayment"
                      :disabled="!form?.amount || submitting"
                      block
                    >
                      <font-awesome-icon
                        v-if="!submitting"
                        :icon="['far', 'credit-card']"
                        class="anticon"
                      />
                      {{ labels.pay }}
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </ValidationObserver>
        </a-card>
      </div>
    </a-spin>
    <!-- NOTIFICATION MODAL -->
    <a-modal
      v-if="notification"
      :visible="notification.visible"
      :closable="true"
      :footer="null"
      centered
      class="notification-modal"
      :loading="this.submitting"
      @cancel="resetNotificationModal"
    >
      <div class="notification-modal-title">
        <a-icon :type="notification.icon" class="notification-modal-icon" />
        <span>{{ notification.title }}</span>
      </div>
      <p
        v-if="notification.message"
        class="notification-modal-description"
        v-html="notification.message"
      />
      <a-button
        v-if="
          notification.visible &&
          notification.title !== labels.creditCardClientTips.process.redirecting
        "
        type="primary"
        @click="handleRedirectPaymentClient"
        class="notification-modal-btn"
        ghost
        block
        :loading="this.submitting"
      >
        {{ labels.creditCardClientTips.process.btnProcess }}
      </a-button>
    </a-modal>
  </a-layout>
</template>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import loadingMixin from "@/mixins/loadingMixin";
import TitleBreadcrumb from "@/components/layout/client/TitleBreadcrumb.vue";
import Input from "@/components/core/VeeValidateForm/Input";
import { pageTitle } from "@/utils/utils";
import labels from "@/utils/labels";
import { mapActions, mapGetters, mapState } from "vuex";
import moment from "moment";
import "moment-timezone";
import _ from "lodash";
import { VueMaskFilter } from "v-mask";
import { mask } from "vue-the-mask";
import accounting from "accounting";
import {
  DATE_FORMAT,
  hasRoles,
  PAYMENT_CLIENTS,
  roles,
} from "../../../utils/utils";
import tetherLogo from "@/assets/images/tether-usdt.png";
import CryptAPI from "@/utils/cryptapi";
import UserBankAccountComponent from "@/components/UserBankAccountComponent.vue";

export const TYPE = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
  TRANSFER: "TRANSFER",
  BANK_TRANSFER: "BANK_TRANSFER",
};

export const ORIGIN = {
  TRANSFER: "TRANSFER",
  TETHER: "TETHER",
  CREDIT_CARD: "CREDIT_CARD",
};

export const CURRENCY = {
  DOP: "DOP",
  USD: "USD",
  BTC: "BTC",
};

export const ACCOUNT_TYPE = {
  SAVINGS: "SAVINGS",
  CHECKING: "CHECKING",
};

const initialState = {
  type: TYPE.DEPOSIT,
  origin: undefined,
  currency: {
    value: CURRENCY.DOP,
    label: labels.transactionForm.currency[CURRENCY.DOP],
  },
  amount: undefined,
  bank: undefined,
  account: undefined,

  voucher: [],
  reference: undefined,

  account_type: ACCOUNT_TYPE.SAVINGS,
  identification_card: undefined,
  destination_account_phone: undefined,
  destination_user: undefined,
  addToMyAccounts: false,
  password: undefined,
};

const defaultNotification = {
  visible: false,
  title: "",
  message: "",
  icon: "",
  theme: "",
};

export default {
  components: {
    TitleBreadcrumb,
    ValidationObserver,
    ValidationProvider,
    Input,
    UserBankAccountComponent,
  },
  name: "TransactionForm",
  directives: { themask: mask },
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.transactionForm.subtitle),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.transactionForm.subtitle,
      },
    ],
  },
  data() {
    return {
      labels: {
        ...labels.transactionForm,
        appName: labels.appName,
      },
      transaction: null,
      bankAccount: null,
      form: _.cloneDeep(initialState),
      TYPE,
      ORIGIN,
      currencies: Object.values(CURRENCY).map((currency) => ({
        value: currency,
        label: labels.transactionForm.currency[currency],
      })),
      origins: Object.values(ORIGIN)
        .filter((ori) => ori === ORIGIN.TRANSFER)
        .map((origin) => ({
          value: origin,
          label: labels.transactionForm.origin[origin],
        })),
      fileList: [],
      submitting: false,
      tetherLogo,
      ca: null,
      paymentBase64: null,
      paymentUri: null,
      loadingQRCode: false,
      transactionToken: null,
      creditCardClient: null,
      creditCardClientLinks: [],
      loadingCreditCardClientLinks: false,
      CURRENCY,
      notification: _.cloneDeep(defaultNotification),
      acceptedPolicies: false,
      transferFee: 0,
      amount: 0,
      promotionAvailable: null,
    };
  },
  async created() {
    await this.fetchCryptapiConfig();
    if (!this.loggedUser?.tfd) await this.loadTransferFee();
    if (this.$route?.query?.type) {
      if (this.loggedUser?.dww && this.$route.query.type === TYPE.WITHDRAW) {
        this.$router.push({
          name: "transaction-request",
          query: { type: TYPE.DEPOSIT },
          replace: true,
        });
      } else {
        if (this.$route?.query?.type) {
          this.form.type = this.$route.query.type;
        }
      }
    }
    this.$nextTick(async () => {
      await this.$store.dispatch("systemConfig/fetchWhatsappConfig");
    });
  },
  mounted() {
    if (this.$route.query.moneygrator === "success") {
      this.$notification["success"]({
        message: "Depósito realizado con éxito.",
      });
      let query = { ...this.$route.query };
      delete query.moneygrator;
      this.$router.replace({ query });
    } else if (this.$route.query.moneygrator === "fail") {
      this.$notification["error"]({
        message: "El depósito no se pudo completar.",
      });
      let query = { ...this.$route.query };
      delete query.moneygrator;
      this.$router.replace({ query });
    }
  },
  computed: {
    ...mapState("layout", ["screenWidth"]),
    ...mapState("clientAuth", ["user"]),
    ...mapGetters("clientAuth", [
      "getLoggedUser",
      "isInBlackList",
      "isCreditCardEnabled",
    ]),
    ...mapGetters({
      cryptapi: "systemConfig/getCryptApiConfig",
    }),
    ...mapState({
      whatsapp: (state) => state.systemConfig.whatsapp,
    }),
    loggedUser() {
      return this.getLoggedUser;
    },
    depositAccountsLink() {
      if (!this.loggedUser?.dagl) {
        return "";
      }
      return `<a href="${this.loggedUser.dagl}" class="link" target="_blank">aqui</a>`;
    },
    whatsappLink() {
      const a = document.createElement("a");
      a.href = `https://wa.me/${this.whatsapp}?text=${encodeURIComponent(
        this.labels.whatsappMessage
      )}`;
      a.target = "_blank";
      a.classList.add("whatsapp-link");
      a.style.color = "inherit";
      const phone = document.createElement("span");
      phone.innerHTML = this.$options.filters.mask(
        this.whatsapp,
        "+# (###) ###-####"
      );
      a.appendChild(phone);
      return a.outerHTML;
    },
    isTetherValid() {
      const { whatsapp } = this.getLoggedUser;
      return this.form.origin === ORIGIN.TETHER && whatsapp && this.form.amount;
    },
    isCreditCardClientValid() {
      return (
        this.form.origin === ORIGIN.CREDIT_CARD && this.creditCardClient?.link
      );
    },
    tetherLink() {
      const { whatsapp } = this.getLoggedUser;
      return this.isTetherValid && this.cryptapi?.solucredito_mifosx_api_url
        ? `${
            this.cryptapi?.solucredito_mifosx_api_url
          }?phone=${whatsapp}&amount=${this.getConversion(
            this.form.amount
          )}&verified=true&token=${this.transactionToken}`
        : "javascript:;";
    },
    creditCardClientLink() {
      const percentage = this.creditCardClient?.percentage || 0;
      const amount = (this.form.amount || 0) * (1 + percentage / 100);
      return this.isCreditCardClientValid
        ? this.creditCardClient.link
            .replace("{amount}", amount)
            .replace("{percentage}", percentage)
        : null;
    },
    isMobile() {
      return this.screenWidth < 592;
    },
    isTabletDown() {
      return this.screenWidth < 768;
    },
    isWithdraw() {
      return this.form.type === TYPE.WITHDRAW;
    },
    isDeposit() {
      return this.form.type === TYPE.DEPOSIT;
    },
    isTransfer() {
      return this.form.type === TYPE.TRANSFER;
    },
    isCreditCard() {
      return this.form.origin === ORIGIN.CREDIT_CARD;
    },
    isSeller() {
      const { accessRoles = [] } = this.getLoggedUser;
      return hasRoles(accessRoles, [roles.client.ROLE_SELLER]);
    },
    userBalance() {
      return this.user?.balance || 0;
    },
    userWithdrawBalance() {
      return this.user?.withdraw_balance || 0;
    },
    balance() {
      return this.loggedUser?.pwo ? this.userWithdrawBalance : this.userBalance;
    },
    minCreditCardAmount() {
      // if (!this.cryptapi?.exchange_rate_usd_to_dop) return 600;
      // const amount =
      //   parseFloat(this.cryptapi.exchange_rate_usd_to_dop || "0") * 10;
      // return amount < 600 ? 600 : amount;
      return 2000;
    },
    userDepositPercentageCommission() {
      return (
        this.getLoggedUser?.commissionProfile?.schema?.find(
          (c) => c.type === "USER_DEPOSIT_COMMISSION"
        )?.percentage || null
      );
    },
  },
  methods: {
    ...mapActions("transactions", [
      "getPromotionAvailable",
      "requestTransaction",
      "generateTransactionToken",
      "getSkyChainPaymentLink",
      "getMoneygratorPaymentLink",
      "getChargemoneyPaymentLink",
      "getPaywallPaymentLink",
      "getMatrevicPaymentLink",
    ]),
    ...mapActions(["fetchAccountByPhone"]),
    ...mapActions("systemConfig", [
      "fetchCryptapiConfig",
      "getCreditCardPaymentClientLinks",
      "getCraueConfigByNameClient",
    ]),
    ...mapActions("clientAuth", ["twb", "checkSession"]),
    popupAfterTransferDeposit(isWithinWorkingHours = false) {
      // modal with close btn
      this.$confirm({
        title: "¡Importante!",
        class: "important-modal",
        content: (
          <div>
            {isWithinWorkingHours ? (
              <div class="message-container">
                <p>
                  Ya conoces nuestro nuevo metodo de pago con tarjeta de
                  credito?
                </p>
                <p>Escribenos y descubre los beneficios.</p>
                <p>
                  <a href={"https://wa.link/9ukmq9"} target="_blank">
                    Haz Click Aqui
                  </a>
                </p>
              </div>
            ) : (
              <div class="message-container">
                <p>
                  Actualmente nuestros agentes estan fuera de servicio.
                  Estaremos procesando la verificacion de su deposito dentro de
                  nuestro horario laboral:
                </p>
                <p>Lunes - Domingo</p>
                <p>8:30 AM - 11:00 PM</p>
                <p>
                  Si deseas aplicar recargas instantaneas a su cuenta, puede
                  hacerlo habilitando los pagos con tarjeta de credito.
                </p>
                <p>
                  <a href={"https://wa.link/9ukmq9"} target="_blank">
                    Haz Click Aqui
                  </a>
                </p>
              </div>
            )}
          </div>
        ),
        closable: true,
        width: this.isMobile ? "100%" : "600px",
        cancelButtonProps: { style: { display: "none" } },
        okText: "Cerrar",
      });
    },
    whatsappLinkMessage(message = this.labels.whatsappMessage) {
      const a = document.createElement("a");
      a.href = `https://wa.me/${this.whatsapp}?text=${encodeURIComponent(
        message
      )}`;
      a.target = "_blank";
      a.classList.add("whatsapp-link");
      a.style.color = "inherit";
      const phone = document.createElement("span");
      phone.innerHTML = this.$options.filters.mask(
        this.whatsapp,
        "+# (###) ###-####"
      );
      a.appendChild(phone);
      return a.outerHTML;
    },
    scrollIntoView(ref) {
      if (ref) {
        ref.$el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    setAmount(amount) {
      this.form.amount = amount;
    },
    setCreditCardClient(client) {
      this.creditCardClient = client;
      this.form.amount = client.amount;
    },
    loadVariable(label, variables = {}) {
      return label.replace(/{{(\w+)}}/g, (match, p1) => variables[p1] || match);
    },
    isValidPhone(phone) {
      return phone && phone.replace(/\D/g, "").length === 10;
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    },
    async handleSubmit() {
      if (this.submitting) return;
      try {
        // VALIDATE VOUCHER WHEN DEPOSIT
        if (this.isDeposit && !this.form.voucher.length) {
          this.$error({
            class: "error-modal",
            title: this.labels.formError,
            content: this.labels.voucher.required,
          });
          return;
        }

        // VALIDATE PASSWORD WHEN TRANSFER
        if (this.isTransfer && !this.form.password) {
          this.$error({
            class: "error-modal",
            title: this.labels.formError,
            content: this.labels.password.required,
          });
          return;
        }

        this.submitting = true;
        const form = _.cloneDeep(this.form);
        const formData = new FormData();
        Object.keys(form)
          .filter((key) => !!form[key])
          .forEach((key) => {
            if (key === "voucher") {
              form.voucher.forEach((file) => {
                formData.append("voucher[]", file, file.name);
              });
            } else {
              if (
                ["origin", "currency", "account_type", "bank"].includes(key) &&
                form[key]?.value
              ) {
                formData.append(key, form[key].value);
              } else if (["destination_user"].includes(key) && form[key]) {
                Object.keys(form[key]).forEach((subKey) => {
                  formData.append(`${key}[${subKey}]`, form[key][subKey]);
                });
              } else if (["password"].includes(key)) {
                if (this.isTransfer && form[key]) {
                  formData.append(key, form[key]);
                }
              } else {
                formData.append(key, form[key]);
              }
            }
          });
        const { redirect: isWorkHours = false, message } =
          await this.requestTransaction(formData);

        const refreshSession = [TYPE.TRANSFER, TYPE.WITHDRAW].includes(
          form.type
        );
        const isTransfer = form.type === TYPE.TRANSFER;
        const isWithdraw = form.type === TYPE.WITHDRAW;
        const isDeposit = form.type === TYPE.DEPOSIT;
        this.$success({
          class: "success-modal",
          title: this.labels.success,
          centered: true,
          width: this.isMobile ? "100%" : "600px",
          content: (h) =>
            h(
              "div",
              // vhtml
              {
                domProps: {
                  innerHTML: isTransfer
                    ? this.labels.transferSuccess
                    : message || this.labels.success,
                },
              }
            ),
          onOk: () => {
            if (isWithdraw && form.amount > 100000) {
              this.$success({
                class: "success-modal",
                title: this.labels.success,
                centered: true,
                width: this.isMobile ? "100%" : "600px",
                content: () => (
                  <div>
                    <p>
                      Su solicitud ha sido recibida, en el transcurso de unos
                      minutos estara siendo procesada, para evitar
                      inconvenientes con el procesamiento de su retiro, notara
                      que vamos a dividirlo en multiples transacciones.
                    </p>
                    <p>Muchas gracias!</p>
                  </div>
                ),
              });
            } else if (isDeposit) {
              this.popupAfterTransferDeposit(isWorkHours);
            }
          },
        });

        this.form = _.cloneDeep(initialState);
        if (refreshSession) this.checkSession();
        this.$router.push({ name: "transaction-list" });
      } catch (error) {
        if (error.isAxiosError && [401, 403].includes(error.response.status)) {
          this.$router.push({ name: "login" });
        } else if (error.isAxiosError && error.response.status === 400) {
          this.$notification["error"]({
            message: error.response?.data?.message || error.response?.message,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.length
                  ? error.response?.data?.additional_errors?.map((error) => {
                      return h("li", error);
                    })
                  : h("li", error.response?.data?.message)
              );
            },
          });
        } else {
          this.$notification["error"]({
            message:
              error?.response?.data?.message ||
              error?.response?.message ||
              error.message,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    handlePreviewFile(file) {
      // CREATE IMG AND OPEN IN NEW TAB
      const img = document.createElement("img");
      img.src = file.url || file.thumbUrl;
      img.style.maxWidth = "520px";
      const w = window.open("about:blank", "_blank", "width=520,height=auto");
      w?.document.write(img.outerHTML);
    },
    handleRemoveFile(file) {
      if (file?.uid) {
        this.form.voucher = this.form.voucher.filter(
          (item) => item.uid !== file.uid
        );
        this.fileList = this.fileList.filter((item) => item.uid !== file.uid);
      }
    },
    async beforeUpload(file) {
      const fileBase64 = await this.toBase64(file);
      this.fileList.push({
        uid: file.uid,
        name: file.name,
        status: "done",
        url: fileBase64,
        thumbUrl: fileBase64,
      });
      this.form.voucher.push(file);
      return true;
    },
    dummyRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("ok");
      }, 0);
    },
    async handleRequestDestinationAccountInfo() {
      try {
        if (
          this.isValidPhone(this.form.destination_account_phone) &&
          this.form.destination_account_phone?.replace(/\D/g, "") !==
            this.form.destination_user?.whatsapp
        ) {
          const { data } = await this.fetchAccountByPhone(
            this.form.destination_account_phone
          );
          Object.assign(this.form, {
            destination_user: _.cloneDeep(data),
          });
        }
      } catch (error) {
        this.$notification["error"]({
          message: this.labels.accountNotFound,
          description: this.labels.accountNotFoundDescription,
        });
      }
    },
    async handleRequestQRCode() {
      try {
        this.loadingQRCode = true;
        await this.ca.getAddress();
        const qrCode = await this.ca.getQrcode(
          this.getConversion(this.form.amount),
          parseInt(this.cryptapi.cryptapi_size || 100)
        );
        this.paymentBase64 = `data:image/png;base64,${qrCode.qr_code}`;
        this.paymentUri = qrCode.payment_uri;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingQRCode = false;
      }
    },
    copyPaymentUriToClipboard() {
      const el = document.createElement("textarea");
      el.value = this.paymentUri;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$notification["success"]({
        message: this.labels.copiedToClipboard,
      });
    },
    async generateToken() {
      try {
        const response = await this.generateTransactionToken();
        this.transactionToken = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async generateCrypApiConfig(config) {
      // NOTE: GENERATE TOKEN FOR TRANSACTION
      await this.generateToken();

      const callbackUri = config.cryptapi_callback_uri.replace(
        "{token}",
        this.transactionToken
      );

      const cryptapiParams = {
        post: 1,
        email: config.cryptapi_notify_email,
        callback: callbackUri,
        address: config.cryptapi_address,
      };

      this.ca = new CryptAPI(
        config.cryptapi_ticker,
        config.cryptapi_address,
        callbackUri,
        {},
        cryptapiParams
      );
    },
    getConversion(amount) {
      if (!amount) return 0;

      amount = this.cryptapi?.exchange_rate_usd_to_dop
        ? amount / parseFloat(this.cryptapi.exchange_rate_usd_to_dop || "0")
        : amount;

      return parseFloat(accounting.formatNumber(amount, 2));
    },
    async handleGetCreditCardPaymentClientLinks() {
      try {
        this.loadingCreditCardClientLinks = true;
        const { data } = await this.getCreditCardPaymentClientLinks();
        this.creditCardClientLinks = data;
      } catch (error) {
        this.creditCardClientLinks = [];
        this.$notification["error"]({
          message:
            error.response.message || this.labels.creditCardClientTips.error,
        });
      } finally {
        this.loadingCreditCardClientLinks = false;
      }
    },
    openConfirmCreditCardPaymentClient() {
      this.notification = {
        visible: true,
        title: this.labels.creditCardClientTips.process.title,
        message: this.labels.creditCardClientTips.process.description,
        icon: "check-circle",
      };
    },
    resetNotificationModal() {
      this.notification = _.cloneDeep(defaultNotification);
    },
    async handleRedirectPaymentClient() {
      try {
        this.submitting = true;

        const paymentClient = this.loggedUser.upc;
        if (!paymentClient) {
          this.$notification["error"]({
            message: this.labels.paymentClientUnassigned,
          });
          return;
        }

        const data = {};

        switch (this.loggedUser.upc?.toLowerCase()) {
          case PAYMENT_CLIENTS.CHARGEMONEY.toLowerCase():
            // eslint-disable-next-line no-case-declarations
            const { data: chargeMoney } = await this.getChargemoneyPaymentLink({
              amount: this.form.amount,
            });
            Object.assign(data, chargeMoney);
            break;
          case PAYMENT_CLIENTS.MONEYGRATOR.toLowerCase():
            // eslint-disable-next-line no-case-declarations
            const { data: moneyGrator } = await this.getMoneygratorPaymentLink({
              amount: this.form.amount,
            });
            Object.assign(data, moneyGrator);
            break;
          case PAYMENT_CLIENTS.PAYWALL.toLowerCase():
            // eslint-disable-next-line no-case-declarations
            const { data: paywall } = await this.getPaywallPaymentLink({
              amount: this.form.amount,
            });
            Object.assign(data, paywall);
            break;
          case PAYMENT_CLIENTS.SKYCHAIN.toLowerCase():
            // eslint-disable-next-line no-case-declarations
            const { data: skychain } = await this.getSkyChainPaymentLink({
              amount: this.form.amount,
            });
            Object.assign(data, skychain);
            break;
          case PAYMENT_CLIENTS.MATREVIC.toLowerCase():
            // eslint-disable-next-line no-case-declarations
            const { data: matrevic } = await this.getMatrevicPaymentLink({
              amount: this.form.amount,
            });
            Object.assign(data, matrevic);
            break;
          default:
            this.$notification["error"]({
              message: this.labels.creditCardClientTips.error,
            });
            return;
        }

        this.notification = {
          ..._.cloneDeep(defaultNotification),
          visible: true,
          title: this.labels.creditCardClientTips.process.redirecting,
          icon: "loading",
        };

        setTimeout(() => {
          this.resetNotificationModal();
          this.form = _.cloneDeep(initialState);
          window.location.href = data.uri;
        }, 1500);
      } catch (error) {
        console.error(error);
        if (error.isAxiosError && [401, 403].includes(error.response.status)) {
          this.$router.push({ name: "login" });
        } else if (error.isAxiosError && error.response.status === 400) {
          this.$notification["error"]({
            message: error.response?.data?.message || error.response?.message,
            description: (h) => {
              return h(
                "ul",
                error.response?.data?.additional_errors?.length
                  ? error.response?.data?.additional_errors?.map((error) => {
                      return h("li", error);
                    })
                  : h("li", error.response?.data?.message)
              );
            },
          });
        } else {
          this.$notification["error"]({
            message:
              error?.response?.data?.message ||
              error?.response?.message ||
              error.message,
          });
        }
      } finally {
        this.submitting = false;
      }
    },
    async handleCreditCardPayment() {
      try {
        if (!this.form.amount) {
          this.$notification["error"]({
            message: this.labels.creditCardClientTips.requiredAmount,
          });
          return;
        }
        if (this.form.amount < this.minCreditCardAmount) {
          this.$notification["error"]({
            message: this.labels.creditCardClientTips.minAmount.replace(
              "{min}",
              this.minCreditCardAmount
            ),
          });
          return;
        }
        this.openConfirmCreditCardPaymentClient();
      } catch (error) {
        console.error(error);
      }
    },
    confirmPolicy(value) {
      this.$confirm({
        title: this.labels.confirmPolicy.title,
        content: (
          <p class={"text-content"}> {this.labels.confirmPolicy.content} </p>
        ),
        okText: this.labels.confirmPolicy.okText,
        iconType: "warning",
        class: "confirm-policy",
        closable: false,
        keyboard: false,
        cancelButtonProps: {
          style: {
            display: "none",
          },
        },
        autoFocusButton: "ok",
        width: this.isMobile ? "100%" : 500,
        onOk: () => {
          this.acceptedPolicies = true;
          if (this.form) this.form.origin = value;
        },
        onCancel: () => {
          this.acceptedPolicies = false;
          this.form.origin = undefined;
        },
      });
    },
    handleChangeOrigin(event) {
      event.preventDefault();
      this.form.origin = undefined;
      this.acceptedPolicies = false;
      const { value } = event.target;
      if (value === TYPE.TRANSFER) {
        this.confirmPolicy(value);
      } else {
        if (this.form) this.form.origin = value;
      }
    },
    async loadTransferFee() {
      try {
        const { data } = await this.getCraueConfigByNameClient(
          "percentage_fees_per_transfer"
        );
        this.transferFee = parseFloat((data?.value || "0").replace(/\D/, ""));
      } catch (error) {
        this.transferFee = 0;
      }
    },
    handleConfirmPassword() {
      this.form.password = undefined;
      this.$confirm({
        title: this.labels.confirmPassword.title,
        class: "confirm-transfer-modal",
        content: (h) =>
          h(
            "div",
            {
              class: "confirm-transfer-content",
            },
            [
              h("p", this.labels.confirmPassword.subtitle),
              h(
                "a-form-item",
                {
                  props: {
                    label: this.labels.password.label,
                    labelCol: { span: 24 },
                  },
                },
                [
                  h("a-input-password", {
                    props: {
                      placeholder: this.labels.password.placeholder,
                      value: this.form.password,
                      allowClear: true,
                    },
                    on: {
                      input: (event) => {
                        this.form.password = event.target.value;
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        okText: this.labels.confirmPassword.confirmButtonText,
        okType: "primary",
        icon: "info-circle",
        cancelText: this.labels.confirmPassword.cancelButtonText,
        onOk: async () => {
          this.handleSubmit(this.form);
        },
        onCancel: () => {
          this.form.password = undefined;
        },
      });
    },
    async handleTransferWithdrawBalance() {
      try {
        if (!this.amount) {
          this.$notification["error"]({
            message: this.labels.transferWithdrawBalance.requiredAmount,
          });
          return;
        } else if (this.amount < 1000) {
          this.$notification["error"]({
            message: this.labels.transferWithdrawBalance.minAmount.replace(
              "{min}",
              1000
            ),
          });
          return;
        }

        const response = await this.twb({
          amount: this.amount,
        });

        this.$notification["success"]({
          message:
            response.message || this.labels.transferWithdrawBalance.success,
        });

        this.amount = undefined;

        this.checkSession();
      } catch (error) {
        console.error(error);
        this.$notification["error"]({
          message:
            error?.response?.data?.message ||
            error?.response?.message ||
            error.message ||
            this.labels.transferWithdrawBalance.error,
        });
      }
    },
    openModalTransferWithdrawBalance() {
      this.amount = this.loggedUser?.withdraw_balance || 0;

      // confirmarion modal with input for amount
      this.$confirm({
        title: this.labels.transferWithdrawBalance.title,
        class: "withdraw-balance-modal",
        content: (h) =>
          h(
            "div",
            {
              class: "withdraw-balance-content",
              style: { width: "100%" },
            },
            [
              h("p", this.labels.transferWithdrawBalance.subtitle),
              h(
                "a-form-item",
                {
                  props: {
                    label: this.labels.amount.label,
                    labelCol: { span: 24 },
                    style: { width: "100%" },
                  },
                },
                [
                  h("a-input-number", {
                    style: { width: "100%" },
                    props: {
                      placeholder: this.labels.amount.placeholder,
                      defaultValue: this.amount || 0,
                      min: 1000,
                      precision: 0,
                      step: 100,
                      block: true,
                    },
                    on: {
                      change: (value) => {
                        this.amount = value;
                      },
                    },
                  }),
                ]
              ),
            ]
          ),
        okText: this.labels.transferWithdrawBalance.confirmButtonText,
        okType: "primary",
        icon: "info-circle",
        cancelText: this.labels.transferWithdrawBalance.cancelButtonText,
        onOk: async () => {
          await this.handleTransferWithdrawBalance();
        },
        onCancel: () => {
          this.amount = undefined;
        },
      });
    },
    async checkPromotionAvailable() {
      try {
        const data = await this.getPromotionAvailable();
        this.promotionAvailable = {
          ...data,
          percentage: parseFloat(data.percentage || "0"),
        };
      } catch (error) {
        this.promotionAvailable = null;
      }
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format(DATE_FORMAT.MOMENT_DATE_TIME);
    },
    mask: VueMaskFilter,
    formatCurrency(value) {
      return accounting.formatMoney(value, "RD$ ", 2, ",", ".");
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 0, ",", ".");
    },
  },
  beforeDestroy() {
    this.form = null;
    this.promotionAvailable = null;
    this.submitting = false;
  },
  watch: {
    "$route.query.type": {
      handler: function (val, oldVal) {
        if (oldVal !== val) {
          this.form = _.cloneDeep(initialState);
          this.form.type = val;
          if (val === TYPE.WITHDRAW) {
            this.form.origin = this.origins.find(
              (origin) => origin.value === ORIGIN.TRANSFER
            );
            // focus amountInput refs
            this.$nextTick(() => {
              this.scrollIntoView(this.$refs.amountInput);
              this.$refs.amountInput.$el.querySelector("input").focus();
            });
          } else if (val === TYPE.DEPOSIT) {
            this.checkPromotionAvailable();
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.query.message": {
      handler: function (val, oldVal) {
        if (oldVal !== val) {
          const message =
            val?.toLowerCase() === "success"
              ? this.labels.creditCardClientTips.success
              : val?.toLowerCase() === "cancelled"
              ? this.labels.creditCardClientTips.cancelled
              : null;

          if (message) {
            this.$success({
              class: "success-credit-card-client",
              title:
                val?.toLowerCase() === "success"
                  ? this.labels.creditCardClientTips.successTitle
                  : this.labels.creditCardClientTips.cancelledTitle,
              content: message,
              onOk: () => {
                if (val?.toLowerCase() === "success")
                  this.$router.push({ name: "buy" });
              },
              onCancel: () => {
                if (val?.toLowerCase() === "success")
                  this.$router.push({ name: "buy" });
              },
              okText: this.labels.creditCardClientTips.okText,
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
    "form.type": {
      handler: function (val, oldVal) {
        if (oldVal !== val) {
          if (val === TYPE.DEPOSIT) {
            this.checkPromotionAvailable();
            this.form.account_type = [];
            this.form.email_holder = null;
            this.form.identification_card = null;
            this.form.account_holder = null;
            this.form.phone_holder = null;
          } else if (val === TYPE.WITHDRAW) {
            this.form.origin = this.origins.find(
              (origin) => origin.value === ORIGIN.TRANSFER
            );
            this.form.currency = this.currencies.find(
              (currency) => currency.value === CURRENCY.DOP
            );
          } else {
            this.form.voucher = [];
            this.form.reference = null;
          }
        }
      },
      deep: true,
    },
    "form.origin": {
      handler: function (val, oldVal) {
        if (oldVal !== val) {
          if (val === ORIGIN.TETHER) {
            return;
            // this.generateToken();
            // if (this.form.amount && this.ca) {
            //   this.handleRequestQRCode(this.form.amount);
            // }
          } else if (val === ORIGIN.CREDIT_CARD) {
            this.$nextTick(() => {
              this.scrollIntoView(this.$refs?.amountInput);
              this.refs?.amountInput?.$el?.querySelector("input")?.focus();
            });
          } else {
            this.creditCardClient = null;
          }
        }
      },
      deep: true,
      inmediate: true,
    },
    cryptapi: {
      handler: function (config) {
        if (config) {
          this.generateCrypApiConfig(config);
        }
      },
      deep: true,
      inmediate: true,
    },
    "form.amount": {
      handler: function (val, oldVal) {
        if (
          val &&
          oldVal !== val &&
          val > 0 &&
          this.form.origin === ORIGIN.TETHER
        ) {
          if (this.ca) {
            this.handleRequestQRCode(val);
          }
        }
      },
      deep: true,
    },
    bankAccount: {
      handler: function (val, oldVal) {
        if (val && !_.isEqual(val, oldVal)) {
          this.form.bank = val.bank;
          this.form.account = val.account;
          this.form.account_type = val.account_type;
          this.form.identification_card = val.identification_card;
          this.form.addToMyAccounts = val.save;
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.transaction-form {
  max-width: 100% !important;
  font-family: "Roboto", sans-serif;
  background-color: transparent;
  @media screen and (max-width: $screen-mobile) {
    max-width: 100% !important;
  }
  .transaction-form-title {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 16px;
    color: var(--text);
  }
  .text-white {
    color: var(--text);
  }
  .content-base {
    padding-top: 0;
    @media screen and (max-width: $screen-mobile) {
      max-width: 100% !important;
      padding-top: 0;
    }
  }
  ::v-deep .transaction-form-card {
    background-color: var(--card-shop-bg);
    border-color: var(--card-shop-shadow);
    padding: 1.125rem;
    border-radius: 8px;
    @media screen and (max-width: $screen-mobile) {
      padding: 2.125rem 1rem;
      width: 100%;
    }
    &-title {
      font-size: 1.5rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      line-height: 1.2;
      &.small {
        font-size: 1rem;
      }
    }
    &-subtitle {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 20px;
      color: var(--text);
      text-align: center;
    }
    &-label {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
    }
    &-value {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      border-bottom: 1px dotted var(--text-muted);
    }
    &-total-label {
      font-size: 1rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
    }
    &-total-value {
      font-size: 1.125rem;
      font-weight: 500;
      margin-bottom: 2px;
      color: var(--text);
      text-align: center;
      border-bottom: 1px dashed var(--text);
    }
  }
  ::v-deep .btn-submit {
    background-color: var(--btn-bg-tertiary);
    border-color: var(--btn-bc-tertiary);
    color: var(--btn-text-tertiary);
    transition: all 0.5s ease;
    margin-top: 20px;
    &:hover {
      background-color: var(--btn-bg-tertiary);
      border-color: var(--btn-bc-tertiary);
      color: var(--btn-text-tertiary);
      transition: all 0.5s ease;
    }
  }
  ::v-deep .ant-table {
    &:hover {
      transition: 0.5s ease;
      background: unset;
    }
    tr.ant-table-row:hover {
      transition: 0.5s ease;
      background: var(--table-hover) !important;
    }
    tr:nth-child(2n) {
      transition: 0.5s ease;
      background: var(--table-striped) !important;
    }
    tr.table-row-disabled,
    tr.table-row-disabled:hover {
      color: var(--table-disabled) !important;
      background: var(--table-disabled) !important;
      font-weight: 600;
    }
    tr.table-row-disabled-hover:hover,
    tr.table-row-disabled-hover {
      background: none !important;
      font-weight: 700;
      font-size: 16px;
    }
    .ant-table-tbody > tr.ant-table-row:hover > td {
      transition: 0.5s ease;
      background: none !important;
    }
    &-tbody,
    &-thead {
      color: var(--text) !important;
      tr {
        th {
          color: var(--text) !important;
        }
      }
    }
    &-footer {
      background: transparent;
    }
    @media screen and (max-width: $screen-mobile) {
      &-small {
        border: none;
      }
      &-body {
        margin: 0 1px;
      }
    }
  }
  ::v-deep .custom-radio-button {
    background-color: var(--btn-bg-secondary);
    border-color: var(--btn-bc-secondary);
    color: var(--btn-text-secondary);
    min-width: 180px;
    height: 40px;
    text-align: center;
    position: relative;
    padding: 0 36px;
    font-size: 18px;
    font-weight: 500;
    .flex-icon {
      position: absolute;
      left: 7px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 1.5rem;
    }
    &:hover {
      background-color: var(--btn-bg-tertiary);
      border-color: var(--btn-bc-tertiary);
      color: var(--btn-text-tertiary);
    }
    &:focus {
      background-color: var(--btn-bg-tertiary);
      border-color: var(--btn-bc-tertiary);
      color: var(--btn-text-tertiary);
    }
    &.ant-radio-button-wrapper-checked {
      background-color: var(--btn-bg-tertiary);
      border-color: var(--btn-bc-tertiary);
      color: var(--btn-text-tertiary);
    }
    @media screen and (max-width: $screen-mobile) {
      font-size: 14px;
      height: 32px;
      min-width: 80px;
      padding: 5px 14px;
      transition: all 0.5s ease;
      .flex-icon {
        display: none;
      }
    }
  }
  ::v-deep .origin-radio-group {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 100%;
    .origin-radio-button {
      background-color: var(--btn-bg-secondary);
      border: 1px solid var(--btn-bc-secondary);
      color: var(--btn-text-secondary);
      width: 220px;
      min-height: 67px;
      text-align: left;
      position: relative;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      padding: 12px;
      border-radius: 8px;
      margin-right: 8px;
      @media screen and (max-width: $screen-mobile) {
        width: 100%;
        min-height: 65px;
        font-size: 12px;
        padding: 8px;
        margin-bottom: 8px;
      }
      &:not(:first-child)::before {
        display: none !important;
      }
      .tether-icon {
        width: 30px;
        padding: 2px;
        background-color: var(--text-muted);
        border-radius: 50%;
        margin-right: 8px;
      }
      .anticon {
        font-size: 28px;
        text-align: center;
        margin-right: 8px;
      }
      &.ant-radio-button-wrapper-checked {
        background-color: var(--btn-bg-tertiary);
        border-color: var(--btn-bc-tertiary);
        color: var(--btn-text-tertiary);
      }
    }
  }
  ::v-deep .frequent-amounts-container {
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    max-width: 100%;
    flex-wrap: wrap;
    .btn-frequent-amount {
      background-color: var(--btn-bg-secondary);
      border-color: var(--btn-bc-secondary);
      color: var(--btn-text-secondary);
      text-align: center;
      position: relative;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.5;
      min-width: 65px;
      &:hover {
        background-color: var(--btn-bg-secondary);
        border-color: var(--btn-bc-secondary);
        color: var(--btn-text-secondary);
      }
    }
  }
  ::v-deep .tether-tips-container,
  ::v-deep .deposit-tips-container {
    width: 100%;
    margin: 0;
    padding: 0;
    color: var(--text-active);
    font-size: 18px;
    .deposit-tips {
      margin-bottom: 0 !important;
      line-height: 1.5;
      li {
        margin-top: 10px;
      }
    }
    .tether-tips {
      color: var(--text-active);
      font-size: 18px;
    }
    .btn-tether {
      color: var(--text-active);
      font-size: 22px;
      font-weight: 500;
      &[disabled] {
        color: var(--text-muted) !important;
        cursor: not-allowed !important;
      }
    }
  }
  ::v-deep .ant-form label {
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  ::v-deep .ant-input-number,
  ::v-deep .ant-input {
    background-color: var(--input-bg);
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-active);
    }
  }
  ::v-deep .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-textarea-clear-icon,
    .ant-input-password-icon {
      color: var(--text);
    }
  }
  ::v-deep .has-error .ant-input-affix-wrapper .ant-input,
  ::v-deep .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: color(c-primary);
  }
  ::v-deep .ant-select {
    .ant-select-selection--single {
      color: var(--text);
      background-color: var(--input-bg);
      border: 1px solid var(--text-active);
      &:active,
      &:focus,
      &:hover {
        border-color: var(--text-active);
      }
      .anticon-down {
        color: var(--text);
      }
    }
  }
  ::v-deep .tether {
    &-qr {
      width: 100px !important;
    }
    &-footer {
      grid-column: 1/3;
      width: 100%;
      text-align: right;
      .ant-btn-link {
        color: var(--text);
      }
    }
    &-dir {
      h3 {
        color: var(--text);
        font-size: 1.125rem;
        font-weight: 500;
        margin-bottom: 2px;
        text-align: left;
      }
    }
    &-qr-code {
      width: 100%;
      max-width: 100%;
      min-width: 421px;
      min-height: 132px;
      margin: 0 auto;
      display: grid;
      grid-template-columns: 100px 1fr;
      grid-template-rows: auto auto;
      column-gap: 15px;
      overflow-wrap: anywhere;
      @media screen and (max-width: $screen-mobile) {
        min-width: 100%;
        row-gap: 15px;
      }
      &-container {
        margin-top: 30px;
        .ant-spin-text {
          color: var(--text) !important;
          text-shadow: none !important;
        }
      }
    }
  }
  ::v-deep .notification {
    font-size: 16px;
    .note {
      margin-bottom: 0;
      & > span {
        margin-left: 25px;
        display: block;
        margin-top: 10px;
      }
    }
  }
  ::v-deep .card-credit-card-client {
    background-color: transparent;
    color: var(--text);
    .table-credit-card-client {
      display: flex;
      justify-content: center;
      width: 100%;
      flex-direction: column;
      .table-row-credit-card-client {
        width: 100%;
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        span:first-child {
          font-weight: 500;
        }
        &.total {
          border-top: 1px solid color(--white);
        }
      }
    }
  }
  ::v-deep .transfer-total {
    min-width: 200px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    color: var(--text);
    margin-top: 10px;
    &-title {
      width: 100%;
      justify-self: flex-start;
      text-align: left;
      color: var(--text);
      font-size: 18px;
      text-transform: uppercase;
    }
    &-details-item {
      display: flex;
      justify-content: space-between;
      &:last-child {
        padding-top: 2px;
        border-top: 1px double var(--text-muted);
      }
      .label {
        text-align: left;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
      }
      .value {
        text-align: right;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .withdraw-balance-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;
    .icon-info {
      font-size: 24px;
    }
  }
}
::v-deep input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}
::v-deep .btn-upload {
  color: var(--btn-text-secondary) !important;
  border-color: var(--btn-bc-secondary) !important;
  background-color: var(--btn-bg-secondary) !important;
  transition: all 0.5s ease;
}
::v-deep .anticon-delete {
  color: color(danger) !important;
  font-size: 20px;
  margin-right: 10px;
}
::v-deep .ant-upload {
  width: 100%;
}
::v-deep .ant-upload-list-item-card-actions.picture {
  top: 50%;
  transform: translateY(-50%);
}
::v-deep .ant-spin-dot-item {
  background-color: var(--text-active) !important;
}

::v-deep .notification-modal {
  &-title {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 16px;
    color: var(--text);
    line-height: 1.2;
    &.small {
      font-size: 1rem;
    }
  }
  &-icon {
    font-size: 2rem;
    margin-right: 10px;
    color: var(--text);
  }
  &-description {
    font-size: 1.125rem;
    font-weight: 500;
    margin-bottom: 20px;
  }
  &-btn {
    background-color: var(--btn-bg-primary) !important;
    border-color: var(--btn-bc-primary) !important;
    color: var(--btn-text-primary) !important;
    transition: all 0.5s ease;
    margin-top: 20px;
    &:hover {
      background-color: var(--btn-bg-primary) !important;
      border-color: var(--btn-bc-primary) !important;
      color: var(--btn-text-primary) !important;
      transition: all 0.5s ease;
    }
  }
}
::v-deep .success-credit-card-client {
  .ant-btn-primary {
    background-color: var(--btn-bg-primary) !important;
    border-color: var(--btn-bc-primary) !important;
    color: var(--btn-text-primary) !important;
    transition: all 0.5s ease;
    &:hover {
      background-color: var(--btn-bg-primary) !important;
      border-color: var(--btn-bc-primary) !important;
      color: var(--btn-text-primary) !important;
      transition: all 0.5s ease;
    }
  }
}

::v-deep .withdraw-info {
  text-align: right;
  @media screen and (max-width: $screen-mobile) {
    text-align: left;
  }
  .ant-statistic-title,
  .ant-statistic-content-value-int {
    color: var(--text-warning);
  }
  .ant-statistic-title {
    font-size: 16px;
    font-weight: 400;
    @media screen and (max-width: $screen-mobile) {
      font-size: 1rem;
    }
  }
  .ant-statistic-content-value-int {
    font-size: 24px;
    font-weight: 600;
    @media screen and (max-width: $screen-mobile) {
      font-size: 1.5rem;
    }
  }
}
</style>
<style lang="scss">
@import "~@/assets/scss/variable";
.custom-select {
  background-color: var(--input-bg) !important;
  .ant-select-dropdown-menu-item {
    color: var(--text) !important;
    &:hover {
      background-color: var(--input-bg) !important;
    }
    &-selected,
    &-active {
      background-color: var(--input-bg) !important;
    }
  }
}
.click {
  color: var(--text-info);
  margin-left: 3px;
  &:hover {
    cursor: pointer;
  }
}
.custom-tooltip {
  font-size: 16px;
}
.success-modal {
  font-size: 16px;
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
      p {
        font-size: 16px;
        text-align: justify;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .ant-modal-confirm-btns {
      .ant-btn {
        background-color: var(--btn-bg-secondary) !important;
        border-color: var(--btn-bc-secondary) !important;
        color: var(--btn-text-secondary) !important;
        &:hover,
        &:focus,
        &:active {
          background-color: var(--btn-bg-secondary) !important;
          border-color: var(--btn-bc-secondary) !important;
          color: var(--btn-text-secondary) !important;
        }
        &.ant-btn-primary {
          background-color: var(--btn-bg-primary) !important;
          border-color: var(--btn-bc-primary) !important;
          color: var(--btn-text-primary) !important;
          &:hover {
            background-color: var(--btn-bg-primary) !important;
            border-color: var(--btn-bc-primary) !important;
            color: var(--btn-text-primary) !important;
          }
        }
      }
    }
  }
}
.important-modal {
  .ant-modal-confirm-title {
    font-size: 18px;
    font-weight: 600;
  }
  .message-container {
    font-size: 16px;
    color: var(--text);
    margin-bottom: 10px;
    p {
      margin-bottom: 5px;
      line-height: 1.5;
      a {
        color: var(--text-active);
        font-family: "Roboto", sans-serif;
        text-decoration: none;
        font-weight: 500;
        margin-left: 5px;
        margin-top: 5px;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.important-modal,
.confirm-transfer-modal,
.confirm-policy,
.withdraw-balance-modal,
.error-modal {
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    box-shadow: 0 1px 3px 3px var(--modal-shadow);
    .ant-modal-confirm-title {
      color: var(--text) !important;
    }
    .ant-modal-confirm-content {
      color: var(--text) !important;
      .link {
        color: var(--text-active);
        font-family: "Roboto", sans-serif;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 500;
        margin-left: 5px;
        &:hover {
          text-decoration: underline;
        }
      }
      .error-list-item {
        font-size: 0.95rem;
        margin-bottom: 5px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .ant-modal-confirm-btns {
      .ant-btn {
        background-color: var(--btn-bg-primary) !important;
        border-color: var(--btn-bc-primary) !important;
        color: var(--btn-text-primary) !important;
        &:hover,
        &:focus,
        &:active {
          background-color: var(--btn-bg-primary) !important;
          border-color: var(--btn-bc-primary) !important;
          color: var(--btn-text-primary) !important;
        }
        &.ant-btn-primary {
          background-color: var(--btn-bg-secondary) !important;
          border-color: var(--btn-bc-secondary) !important;
          color: var(--btn-text-secondary) !important;
          &:hover {
            background-color: var(--btn-bg-secondary) !important;
            border-color: var(--btn-bc-secondary) !important;
            color: var(--btn-text-secondary) !important;
          }
        }
      }
    }
    .ant-form-item-label > label {
      color: var(--text) !important;
    }
  }
}
.confirm-policy .ant-modal-confirm-content {
  margin-left: 0 !important;
  .text-content {
    margin-bottom: 0;
    font-size: 1rem !important;
    margin-top: 10px;
  }
}
a.link {
  color: var(--link);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.btn-withdraw {
  background-color: var(--btn-bg-secondary) !important;
  border-color: var(--btn-bc-secondary) !important;
  color: var(--btn-text-secondary) !important;
  transition: all 0.5s ease;
  &:hover {
    background-color: var(--btn-bg-secondary) !important;
    border-color: var(--btn-bc-secondary) !important;
    color: var(--btn-text-secondary) !important;
    transition: all 0.5s ease;
  }
}
</style>
